/** A lap time as messages and the paper write it (no page needed: the server writes them too). */

/** 41843 -> "41.843" (minutes only when there are some). */
export function shortLap(ms: number): string {
  const s = Math.floor(ms / 1000);
  const tail = `${String(s % 60).padStart(2, '0')}.${String(ms % 1000).padStart(3, '0')}`;
  return s >= 60 ? `${Math.floor(s / 60)}:${tail}` : tail.replace(/^0/, '');
}
